import React, { useEffect, useState } from 'react';

const SplashScreen = ({ onComplete }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Show splash screen for 2 seconds, then fade out
    const timer = setTimeout(() => {
      setIsVisible(false);
      // Wait for fade animation to complete before calling onComplete
      setTimeout(() => {
        if (onComplete) {
          onComplete();
        }
      }, 500); // Match the fade-out duration
    }, 2000);

    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <div
      className={`fixed inset-0 bg-gradient-to-br from-primary-500 via-primary-600 to-secondary-500 flex items-center justify-center z-[9999] transition-opacity duration-500 ${
        isVisible ? 'opacity-100' : 'opacity-0'
      }`}
      style={{ pointerEvents: isVisible ? 'auto' : 'none' }}
    >
      <div className="text-center animate-pulse">
        <img
          src="/icon-512.png"
          alt="UttaApp Logo"
          className="w-32 h-32 md:w-40 md:h-40 mx-auto mb-4 drop-shadow-2xl"
        />
        <h1 className="text-3xl md:text-4xl font-bold text-white mt-4">
          UttaApp
        </h1>
      </div>
    </div>
  );
};

export default SplashScreen;

